import {
  GET_TENSILE_TEST_FAILURE,
  GET_TENSILE_TEST_REQUEST,
  GET_TENSILE_TEST_SUCCESS,
} from "./productTestingTypes";

const initialState = {
  loading: false,
  tensileTest: [],
  error: "",
};

const getTensileTestReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TENSILE_TEST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_TENSILE_TEST_SUCCESS:
      return {
        loading: false,
        tensileTest: action.payload,
        error: "",
      };
    case GET_TENSILE_TEST_FAILURE:
      return {
        loading: false,
        tensileTest: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getTensileTestReducer };
